// extracted by mini-css-extract-plugin
export default {"sparkle":"addZwVIor9BqxBvPXXMQ","star1":"uQ_Cas1PrFRQHtao5VKZ","star2":"K54fgejvPvwyPApLRfse","star3":"tlhzwkGjx5hYiKjLMWIU"};